import styled, { css } from 'styled-components';

import { Flex, mediaMixin, spaceMixin, token } from '@zillow/constellation';

export const StyledGrayBackground = styled.div`
  background-color: ${token('colors.coolGray500')};
  padding: ${spaceMixin('xl')} ${spaceMixin('sm')};

  ${mediaMixin(
    'xl',
    css`
      padding: ${spaceMixin('xl')} ${spaceMixin('lg')};
    `,
  )};
`;

export const StyledFlex = styled(Flex)`
  display: flex;
  height: 100%;
  flex-direction: column;
`;

export const StyledMobileDiv = styled.div`
  margin-top: -32px;

  ${mediaMixin(
    'xl',
    css`
      margin-top: 0;
    `,
  )};
`;
